import React from "react";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";

interface StatusFilterProps {
  value: string[];
  onChange: (selected: string[]) => void;
  isUserTypeEnabled: boolean;
  error?: string;
}

const UserTypeFilter: React.FC<StatusFilterProps> = ({
  value,
  onChange,
  isUserTypeEnabled,
  error,
}) => {
  const handleCheckboxChange = (optionValue: string) => {
    const updated = value.includes(optionValue)
      ? value.filter((val) => val !== optionValue)
      : [...value, optionValue];
    onChange(updated);
  };

  if (!isUserTypeEnabled) return null;

  const USER_TYPE_OPTIONS = [
    { label: "Lead", value: "lead" },
    { label: "Customer", value: "customer" },
  ];

  return (
    <div style={{ margin: "8px 4px" }}>
      <div style={{ display: "flex", gap: "30px", alignItems: "center", marginLeft: "7px" }}>
        {USER_TYPE_OPTIONS.map((option) => (
          <label
            key={option.value}
            style={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            <Checkbox
              checked={value.includes(option.value)}
              onChange={() => handleCheckboxChange(option.value)}
              icon={
                <span
                  style={{
                    width: "13px",
                    height: "13px",
                    border: "2px solid #bfc0c2",
                    borderRadius: "4px",
                    display: "inline-block",
                  }}
                />
              }
              checkedIcon={
                <span
                  style={{
                    width: "13px",
                    height: "13px",
                    backgroundColor: "#1976d2",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "2px solid #1976d2",
                  }}
                >
                  <CheckIcon
                    style={{ fontSize: "17px", color: "#fff", fontWeight: 900 }}
                  />
                </span>
              }
            />
            {option.label}
          </label>
        ))}
      </div>
      {error && (
        <div className="error-message" style={{ textAlign: "left" }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default UserTypeFilter;
